import { render, staticRenderFns } from "./common-loader.vue?vue&type=template&id=a1cb46f8&"
import script from "./common-loader.vue?vue&type=script&lang=js&"
export * from "./common-loader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports